<div class="vstack h-100">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title fw-semibold">
            List View Columns
        </h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="dismiss()"
        >
        </button>
    </div>

    <div class="offcanvas-body p-3 overflow-auto">
        <div class="vstack gap-3">
            <div class="vstack gap-1">
                <label class="form-label m-0">
                    Shown Columns
                </label>
                <div
                    class="vstack gap-2"
                    cdkDropList
                    (cdkDropListDropped)="dropColumn($event)"
                >
                    @if (selectedColumns.length > 0) {
                        @for (column of selectedColumns; track column.key) {
                            <div
                                class="d-flex align-items-center justify-content-between gap-3 px-1 py-1 bg-body-tertiary rounded"
                                cdkDrag
                                cdkDragLockAxis="y"
                            >
                                <div class="hstack gap-2 align-items-center px-2 py-2">
                                    <button
                                        type="button"
                                        class="btn btn-link text-body p-0 text-decoration-none"
                                        cdkDragHandle
                                        [attr.aria-label]="'Drag ' + column.label"
                                    >
                                        <i class="bi bi-list fs-4"></i>
                                    </button>
                                    <span>{{ column.label }}</span>
                                    @if (isFixedColumn(column.key)) {
                                        <span class="badge bg-secondary-subtle text-secondary-emphasis">
                                            Always shown
                                        </span>
                                    }
                                </div>
                                <div class="hstack gap-2">
                                    @if (!isFixedColumn(column.key)) {
                                        <button
                                            type="button"
                                            class="btn btn-outline-danger btn-sm"
                                            [attr.aria-label]="'Remove ' + column.label"
                                            (click)="removeColumn(column.key)"
                                        >
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    }
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="text-muted">
                            No columns selected.
                        </div>
                    }
                </div>
                <span class="form-text">
                    Drag to reorder the columns shown in the list view.
                </span>
            </div>
            <div class="vstack gap-1">
                <label class="form-label m-0">
                    Optional Columns
                </label>
                <div class="vstack gap-2">
                    @if (availableOptionalColumns.length > 0) {
                        <select
                            class="form-select"
                            [value]="''"
                            (change)="addOptionalColumn($event)"
                        >
                            <option value="" disabled>Add an optional column...</option>
                            @for (column of availableOptionalColumns; track column.key) {
                                <option [value]="column.key">
                                    {{ column.label }}
                                </option>
                            }
                        </select>
                    } @else {
                        <div class="text-muted">
                            No optional columns available.
                        </div>
                    }
                </div>
                <span class="form-text">
                    Add optional columns here, then reorder them in the shown columns list.
                </span>
            </div>
            @if (venue && venue.questions && venue.questions.length > 0) {
                <div class="vstack gap-1">
                    <label class="form-label m-0">
                        Question Columns
                    </label>
                    <div class="vstack gap-2">
                        @if (availableQuestions.length > 0) {
                            <select
                                class="form-select"
                                [value]="''"
                                (change)="addQuestionColumn($event)"
                            >
                                <option value="" disabled>Add a question column...</option>
                                @for (question of availableQuestions; track question.id) {
                                    <option [value]="question.id">
                                        {{ question.bookingDisplayText }}
                                    </option>
                                }
                            </select>
                        }
                        @if (availableQuestions.length === 0) {
                            <div class="text-muted">
                                No question columns available.
                            </div>
                        }
                    </div>
                    <span class="form-text">
                        Add question columns, then reorder them in the shown columns list.
                    </span>
                </div>
            }
        </div>
    </div>

    <div class="offcanvas-footer p-3 border-top d-flex justify-content-end gap-2">
        <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="dismiss()"
        >
            Cancel
        </button>
        <button
            class="btn btn-primary"
            type="button"
            ngbAutofocus
            (click)="save()"
        >
            Save
        </button>
    </div>
</div>
